<template>
  <div :style="style" class="file-list">

    <div v-for="file in files" :key="file.file.id" class="file-container">
        <div class="file">
            <img src="@/assets/icons/fileicon.png" class="file-icon">
        
            <div>
                <div class="filename">{{$common.realFilename(file.file)}}</div>
                <div class="filesize">{{$common.fileSize(file.file)}}</div>
            </div>
        </div>
        
        <div class="download" v-if="file.file.download" @click="download(file.file)">
            <img src="@/assets/icons/download.png" class="download-icon">
            <div>{{$t('message.download_file')}}</div>
        </div>
        <div class="download" v-if="!file.file.download">
            <img src="@/assets/icons/forbidden.png" class="download-icon">
            <div>{{$t('message.download_forbidden')}}</div>
        </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'FilesComponent',
  data(){
    return {
      style:'',
      files:[]
    }
  },
  props: {
    component: null
  },
  methods:{
    download(file){

      const link = document.createElement("a");
      
      link.href = this.$common.HOST+"/media/download.html?filename="+file.filename;
      
      document.body.appendChild(link);
      
      link.click();
      
      document.body.removeChild(link);

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.component.data.style);

    this.files=this.component.data.data.files;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-list{
    background-color: #fcfcfc;
    border: 1px solid #ebebeb;
    border-radius: 4px;
}
.file-container{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    margin-top: 10px;
    margin-bottom: 10px;
    justify-content: space-between;
}
.file{
    display: flex;
    align-items: center;
}
.file-icon{
    width: 50px;
    margin-right:0.5rem
}
.file-container:last-child{
    border-bottom: 0px solid rgba(0,0,0,1);
}
.filename{
    font-size: 14px;
    color: #353535;
    max-width: 200px;
    line-height: 1.3;
    word-break: break-all;
}
.filesize{
    font-size: 12px;
    color: #8b8a8a;
    margin-top: 4px!important;
    margin-bottom: 10px!important;
    text-align: left;
}
.download{
    text-align: center;
    font-size: small;
}

.download-icon{
    width: 30px;
    margin-right:5px;
}
</style>
